export default "__VITE_ASSET__BsekcH2n__"